<template>
  <div class="py-6">
    <div class="max-w-7xl px-4 sm:px-6 md:px-8">
      <ListHeader
        :title="t('menu.companies')"
        :enableSearch="true"
        :searchPlaceholder="t('companies.searchPlaceholder')"
        :searchTerm="companyListStore.filter"
        @update:search-term="updateFilter"
      >
        <router-link
          to="/companies/new/company"
          class="ml-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-xs hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
        >
          {{ t('companies.createNew') }}
        </router-link>
      </ListHeader>

      <ErrorMessage
        v-if="companyListStore.error"
        :error="companyListStore.error"
      />

      <List
        v-slot="{ entity: company }"
        :entities="companyListStore.companies"
        :page="companyListStore.page"
        :loading="companyListStore.isLoading"
        :updatePageNumber="updatePageNumber"
        :updatePageSize="updatePageSize"
      >
        <router-link
          :to="`/companies/${company.id}/company`"
          class="block text-indigo-600 hover:bg-gray-50 focus:underline focus:outline-hidden"
        >
          <div class="flex items-center px-4 py-4 sm:px-6">
            <div class="flex min-w-0 flex-1 items-center">
              <div class="flex min-w-0 md:gap-10">
                <div class="hidden md:col-span-1 md:block">
                  <div class="flex h-12 w-24 items-center justify-center">
                    <img
                      v-if="company.logoUrl"
                      :src="
                        getImgSrc({
                          imgUrl: company.logoUrl,
                          height: 48,
                          width: 96,
                          trim: 'color',
                          trimColor: 'fff',
                        })
                      "
                      :alt="`Logo ${company.name}`"
                    />
                    <BuildingOffice2Icon
                      v-else
                      class="h-12 w-12 text-gray-300"
                    />
                  </div>
                </div>
                <div class="flex items-center md:col-span-3">
                  <p class="truncate text-sm font-medium">
                    {{ company.name }}
                    <span
                      v-if="company.staffingAgency"
                      class="inline-flex items-center rounded-full bg-fuchsia-100 px-2.5 py-0.5 text-xs font-medium text-fuchsia-800 lg:ml-2"
                      >{{ t('company.staffingAgency') }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <div>
              <ChevronRightIcon
                class="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </div>
          </div>
        </router-link>
      </List>
    </div>
  </div>
</template>

<script setup>
import ErrorMessage from '../components/ErrorMessage.vue'
import ListHeader from '../components/ListHeader.vue'
import List from '../components/List.vue'
import { getImgSrc } from '../utils/imgSrc.js'
import { useCompanyListStore } from '../store/companyListStore'
import { useI18n } from 'vue-i18n'
import { ChevronRightIcon } from '@heroicons/vue/20/solid'
import { BuildingOffice2Icon } from '@heroicons/vue/24/outline'

const companyListStore = useCompanyListStore()
const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})
companyListStore.load()

const updatePageSize = (pageSize) => {
  companyListStore.page.size = pageSize
  companyListStore.load()
}

const updateFilter = (filter) => {
  companyListStore.filter = filter
  companyListStore.page.number = 1
  companyListStore.load()
}
const updatePageNumber = (number) => {
  companyListStore.page.number = number
  companyListStore.load()
}
</script>
